import React, { Component } from 'react';
import { DatePicker, TimePicker, MobileTimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { dateTimeDailyOrMonthlyRounding } from '../../utils/ReportDateTimeUtils';
import { setGlobalDateTime } from '../../../../state/datetime/DateTime.actions';
import { SET_GLOBAL_DATETIME } from '../../../../state/datetime/DateTime.types';
import { connect } from 'react-redux';
import Store from '../../../../../redux/Store';
import { checkDateTimeCorrectness } from '../../utils/ReportDateTimeUtils';
import Constants from '../../../../constants/Constants';

var filterSpacingEndTimeStyle = { hidden: false };

class DateTimeRangeInput extends Component {
  constructor(props) {
    super(props);
    this.state = this.buildState(props);

    this.onChangeDateTime = this.onChangeDateTime.bind(this);
  }

  componentWillMount() {
    this.setVisibility(this.props.settings.mode);

    if (this.props.settings != undefined && this.props.settings.mode != undefined) {
      let startType = this.props.settings.mode.startType;
      let endType = this.props.settings.mode.endType;

      //save to redux startype//endtype
      this.saveTimeSelectionMode(startType, endType);
    }

    this.handleNotification();
  }

  componentWillReceiveProps(newProps) {
    this.setVisibility(newProps.settings.mode);

    var newState = this.buildState(newProps);
    if (newState) {
      this.handleStatePropagation(newState);
    }
  }

  saveTimeSelectionMode = (startType, endType) => {
    Store.dispatch(
      setGlobalDateTime({
        type: SET_GLOBAL_DATETIME,
        startType: startType,
        endType: endType,
      })
    );
  };

  setVisibility = (mode) => {
    if (mode.selectionType && mode.selectionType == 'single') {
      filterSpacingEndTimeStyle = Object.assign([], filterSpacingEndTimeStyle, {
        hidden: true,
      });
    } else {
      filterSpacingEndTimeStyle = Object.assign([], filterSpacingEndTimeStyle, {
        hidden: false,
      });
    }
  };

  onChangeDateTime = (target, newDate) => {
    let mode = this.props.settings.mode;
    let startType = mode.startType;
    let endType = mode.endType;

    let newRange = {
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
    };

    if (target == 'from') {
      newRange.dateFrom = newDate;

      if (mode.selectionType && mode.selectionType == 'single') {
        let newDateFrom = newDate.clone();
        newRange.dateTo =
          endType == 'month' ? newDateFrom.add(1, 'months') : newDateFrom.add(1, 'days');
      }
    } else {
      newRange.dateTo = newDate;
    }

    //save to redux startype//endtype
    this.saveTimeSelectionMode(startType, endType);

    this.handleStatePropagation(newRange);
  };

  //solve query strings || previous state if available || defaults
  buildState = (props) => {
    var newStartString =
      props.query[this.props.settings.key[0]] ||
      moment.utc().add(this.props.settings.defaultValue[0], 'm').format();
    var newEndString =
      props.query[this.props.settings.key[1]] ||
      moment.utc().add(this.props.settings.defaultValue[1], 'm').format();

    if (
      !this.state ||
      this.state.dateFrom.format() != newStartString ||
      this.state.dateTo.format() != newEndString
    ) {
      return {
        dateFrom: moment.utc(newStartString),
        dateTo: moment.utc(newEndString),
      };
    } else {
      return null;
    }
  };

  isQueryDifferentFromState = () => {
    return (
      !this.state ||
      this.state.dateFrom.format() != this.props.query[this.props.settings.key[0]] ||
      this.state.dateTo.format() != this.props.query[this.props.settings.key[1]]
    );
  };

  handleStatePropagation = (newRange) => {
    this.setState({ ...this.state, ...newRange }, () => this.handleNotification());
  };

  handleNotification = () => {
    if (this.isQueryDifferentFromState()) {
      var changedQuery = {
        [this.props.settings.key[0]]: this.state.dateFrom.format(),
        [this.props.settings.key[1]]: this.state.dateTo.format(),
      };

      this.props.onChanged(changedQuery, 'filter-dateTime');
    }
  };

  render() {
    let mode = this.props.settings.mode;
    let error = checkDateTimeCorrectness(this.state.dateFrom, this.state.dateTo);
    return (
      <div className="u-fx u-fx-column">
        <div className="u-fx u-fx-align-end">
          <DatePicker
            slotProps={{
              textField: () => ({
                'data-qa': 'qa-date-from',
                error: error != null,
              }),
              actionBar: {
                // The actions will be the same between desktop and mobile
                actions: ['cancel', 'accept'],
              },
            }}
            className="u-mr-half"
            closeOnSelect={false}
            label={mode.selectionType && mode.selectionType == 'single' ? 'Date' : 'Date from'}
            value={this.state.dateFrom}
            placeholder="Date from"
            maxDate={moment.utc().add(1, 'months').startOf('month')}
            onAccept={(dateTime) => this.onChangeDateTime('from', dateTime)}
            format={mode.startType == 'month' ? 'YYYY-MM' : 'YYYY-MM-DD'}
            openTo={'year'}
            {...(mode.startType == 'month' ? { views: ['year', 'month'] } : {})}
          />
          {mode.startType == 'dateTime' ? (
            <MobileTimePicker
              slotProps={{
                textField: () => ({
                  'data-qa': 'qa-time-from',
                  error: error != null,
                }),
              }}
              className="u-mr-half"
              ampm={false}
              label="Time from"
              value={this.state.dateFrom}
              onAccept={(dateTime) => this.onChangeDateTime('from', dateTime)}
            />
          ) : null}
          {mode.endType != 'time' ? (
            <DatePicker
              slotProps={{
                textField: () => ({
                  ...filterSpacingEndTimeStyle,
                  'data-qa': 'qa-date-to',
                  error: error != null,
                }),
                actionBar: {
                  // The actions will be the same between desktop and mobile
                  actions: ['cancel', 'accept'],
                },
              }}
              className="u-mr-half"
              closeOnSelect={false}
              label="Date to"
              value={this.state.dateTo}
              placeholder="Date to"
              maxDate={moment.utc().add(1, 'months').startOf('month')}
              onAccept={(dateTime) => this.onChangeDateTime('to', dateTime)}
              format={mode.endType == 'month' ? 'YYYY-MM' : 'YYYY-MM-DD'}
              openTo={'year'}
              {...(mode.endType == 'month' ? { views: ['year', 'month'] } : {})}
            />
          ) : null}
          {mode.endType == 'dateTime' || mode.endType == 'time' ? (
            <MobileTimePicker
              slotProps={{
                textField: () => ({
                  ...filterSpacingEndTimeStyle,
                  'data-qa': 'qa-time-to',
                  error: error != null,
                }),
              }}
              className="u-mr-half"
              ampm={false}
              label="Time to"
              value={this.state.dateTo}
              onAccept={(dateTime) => this.onChangeDateTime('to', dateTime)}
            />
          ) : null}
        </div>
        {this.props.settings.mode && this.props.settings.mode.granularity ? (
          <div className="u-fx u-fx-align-end u-mt-full ">
            <p className="u-italic" style={{ color: Constants.COLORS.WARNING }}>
              Will display one data point for each period of{' '}
              {moment.duration(this.props.settings.mode.granularity).locale('en').humanize()} of raw
              data, from {this.state.dateFrom.format('YYYY-MM-DD HH:mm')} to{' '}
              {this.state.dateTo.format('YYYY-MM-DD HH:mm')}
            </p>
          </div>
        ) : null}
        {error != null ? (
          <div className="u-fx u-fx-align-end u-mt-full ">
            <p className="u-italic" style={{ color: Constants.COLORS.ERROR }}>
              {error}
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  globalDateTime: state.globalDateTime ? state.globalDateTime : null,
});

export default connect(mapStateToProps)(DateTimeRangeInput);
